//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import i18n from '@/utils/i18n';
import GridColWidget from '@/components/form-designer/form-widget/container-widget/grid-col-widget';
import containerMixin from '@/components/form-designer/form-widget/container-widget/containerMixin';
import ContainerWrapper from '@/components/form-designer/form-widget/container-widget/container-wrapper';
import refMixinDesign from '@/components/form-designer/refMixinDesign';
export default {
  name: 'grid-widget',
  componentName: 'ContainerWidget',
  mixins: [i18n, containerMixin, refMixinDesign],
  inject: ['refList'],
  components: {
    ContainerWrapper: ContainerWrapper,
    GridColWidget: GridColWidget
  },
  props: {
    widget: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object
  },
  computed: {
    selected: function selected() {
      var _this$designer;
      return this.widget.id === ((_this$designer = this.designer) === null || _this$designer === void 0 ? void 0 : _this$designer.selectedId);
    },
    customClass: function customClass() {
      return this.widget.options.customClass || '';
    }
  },
  watch: {
    //
  },
  created: function created() {
    this.initRefList();
  },
  mounted: function mounted() {
    //
  },
  methods: {}
};